import React from 'react';
import { css } from 'emotion';
import { useT } from 'client/i18n/hooks/useT';
import { Logos, WordPressDotComLogo } from './Logos';
import { LogoWrapper, DesktopHeading, MobileHeading } from './styles';
import { COLOR_DARK_PURPLE } from '../../../MarketingPagesShared/styles';

export function WordPressHero({ fillColor }: { fillColor?: string }) {
  const t = useT();
  const color = fillColor || COLOR_DARK_PURPLE;
  return (
    <>
      <DesktopHeading
        aria-label={t(
          'SignupPage.WordPressHero.AriaLabel',
          'In partnership with WordPress.com',
          'Anchor partnership with WordPress screenreader information'
        )}
        className={css`
          margin: 0;
        `}
      >
        <Logos fillColor={fillColor} />
      </DesktopHeading>
      <MobileHeading
        aria-label={t(
          'SignupPage.WordPressHero.AriaLabel',
          'In partnership with WordPress.com',
          'Anchor partnership with WordPress screenreader information'
        )}
        className={css`
          margin: 0;
          color: ${color};
        `}
      >
        {t(
          'SignupPage.WordPressHero.Heading',
          'In partnership with {wordpressLogo}',
          'Anchor partnership with WordPress message',
          {
            wordpressLogo: (
              <LogoWrapper
                aria-hidden={true}
                className={css`
                  width: 200px;
                  margin: auto;
                  padding-top: 4px;
                `}
                key="wordpressLogo-wphero"
              >
                <WordPressDotComLogo fillColor={color} />
              </LogoWrapper>
            ),
          }
        )}
      </MobileHeading>
    </>
  );
}
